
<div class="text-center">


  <mat-form-field appearance="legacy" class="w-full">
    <input matInput [placeholder]="placeholder" [matAutocomplete]="auto" [(ngModel)]="text" (input)="filterOptions(text)" [required]="required" [disabled]="disabled">
  </mat-form-field>
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option *ngFor="let opt of filteredOptions" [value]="opt.name" (click)="check(opt)">
      <span>{{opt.name}}</span>
    </mat-option>
  </mat-autocomplete>
  
  
</div>




